// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"YL-z","carouselContainer":"ZL-z"};